import {
  SettingAccess,
  SettingDirectWriteGrant,
  SettingVisibility,
  SettingWriteGrant,
} from "./types";

export const SettingVisibilityRank = {
  merchant: 0,
  admin: 1,
  restricted: 2,
} as const satisfies Record<SettingVisibility, number>;

export function canViewSetting(
  viewerVisibility: SettingVisibility,
  settingVisibility: SettingVisibility,
): boolean {
  return (
    SettingVisibilityRank[viewerVisibility] >=
    SettingVisibilityRank[settingVisibility]
  );
}

export function getMostRestrictiveSettingVisibility(
  first: SettingVisibility,
  second: SettingVisibility,
): SettingVisibility {
  return SettingVisibilityRank[first] >= SettingVisibilityRank[second]
    ? first
    : second;
}

export function canReadSetting(
  viewerVisibility: SettingVisibility,
  access: SettingAccess,
): boolean {
  return canViewSetting(viewerVisibility, access.read.minVisibility);
}

export function getDirectSettingWriteGrants(
  viewerVisibility: SettingVisibility,
  access: SettingAccess,
): readonly SettingDirectWriteGrant[] {
  if (access.write.mode !== "grants") {
    return [];
  }

  return access.write.grants
    .filter(isDirectWriteGrant)
    .filter((grant) => canViewSetting(viewerVisibility, grant.minVisibility));
}

export function canDirectlyWriteSetting({
  viewerVisibility,
  permissions,
  access,
}: {
  viewerVisibility: SettingVisibility;
  permissions: readonly string[];
  access: SettingAccess;
}): boolean {
  return getDirectSettingWriteGrants(viewerVisibility, access).some((grant) => {
    return !grant.permission || permissions.includes(grant.permission);
  });
}

function isDirectWriteGrant(
  grant: SettingWriteGrant,
): grant is SettingDirectWriteGrant {
  return grant.method === "direct";
}
